import TileSource from './TileSource';

const tileSource = new TileSource(process.env.REACT_APP_LAYER_URL || '');

function addRegionLayer(map, layer, configData) {
  const config = configData.REGION[layer];
  tileSource.addRegionSource(map, config);
  tileSource.addRegionLayers(map, config);
}

function removeRegionLayer(map, configData, layer) {
  const config = configData.REGION[layer];
  tileSource.removeRegion(map, config);
}

function addLayerLocal(map, layer, configData, tidalLevel) {
  const config = configData.IMPACT[layer];

  // Linear relationship: tidal level + 0.7 = tidal level in DEM
  tidalLevel = (Number(tidalLevel) - Number(0.7)).toFixed(2);
  const sourceLayerName = (tidalLevel).toString().replace(/\./g, '_');
  const layerPrefix = config.SOURCE_LAYER_PREFIX || '';

  tileSource.addImpactSource(map, config, sourceLayerName);
  tileSource.addImpactLayer(map, config, `${layerPrefix}${sourceLayerName}`);
}

function removeLayer(map, configData, layer) {
  const config = configData.IMPACT[layer];
  tileSource.removeImpact(map, config);
}

export { addLayerLocal, removeLayer, addRegionLayer, removeRegionLayer };
